import { useState } from "react";

// Material components
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

// Styles
import useStyles from "./PaceAccordion.styles";

// Utils
import { whiteSpaceToHyphen } from "utils";
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";

// Types
type paceAccordionItemParam = {
    index: number;
    summary: string[];
    styleConfig: {
        colors: string[];
        shadow: string;
    };
    details: {
        lhs_label: string;
        rhs_label: string;
    }[];
};

const PaceAccordionItem = ({ styleConfig, summary, details, index }: paceAccordionItemParam): JSX.Element => {
    const styles = useStyles(styleConfig);
    const [expanded, setExpanded] = useState<boolean>(false);

    const handleChange = () => setExpanded(!expanded);

    return (
        <>
            <Accordion
                expanded={expanded}
                onChange={handleChange}
                classes={{ root: styles.accordionRoot, expanded: styles.accordionExpanded }}
            >
                <AccordionSummary
                    aria-controls={`panel${index}d-content`}
                    id={`panel${index}d-header`}
                    classes={{
                        root: styles.summaryRoot,
                        content: styles.summaryContent,
                        expanded: styles.summaryExpanded,
                    }}
                >
                    <Typography variant="subtitle1" color="text.alt">
                        {summary[0]}
                    </Typography>
                    <Box className={styles.accordionIconWrapper}>
                        <CustomIcon
                            icon={icons.chevronDownThin}
                            classes={{ root: styles.arrow }}
                            style={{
                                color: "white",
                                transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                            }}
                        />
                    </Box>
                    <Typography variant="subtitle1" color="text.alt" sx={{ textAlign: "right" }}>
                        {summary[1]}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails classes={{ root: styles.detailsRoot }}>
                    <List disablePadding={true} classes={{ root: styles.listRoot }}>
                        {details.map(({ lhs_label, rhs_label }) => (
                            <ListItem
                                key={`${whiteSpaceToHyphen(lhs_label)}-${whiteSpaceToHyphen(rhs_label)}`}
                                classes={{ root: styles.listItemRoot }}
                            >
                                <ListItemText
                                    primary={lhs_label}
                                    className={styles.lhsLabel}
                                    classes={{ primary: styles.listItemTextPrimary }}
                                />
                                <ListItemText
                                    primary={rhs_label}
                                    className={styles.rhsLabel}
                                    classes={{ primary: styles.listItemTextPrimary }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default PaceAccordionItem;
